var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      !_vm.options.searchInput ||
      !_vm.options.searchInput.ext ||
      !_vm.options.searchInput.ext.hidden
    )?_c('x-input',_vm._b({attrs:{"x-model":_vm.search},on:{"input":_vm.onSearch,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSearch.apply(null, arguments)}}},'x-input',_vm.options.searchInput.attrs,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }